import { IndividualRating } from "@/components/Rating";
import { Box, Flex, Text } from "@chakra-ui/react";

type ReviewProps = {
  durabilityGrade: number;
  stabilityGrade: number;
  wetGripGrade: number;
  noiseLevel: number;
  drivabilityGrade: number;
  confortGrade: number;
  clientName: string;
  date: string;
  vehicle: string;
  comment: string;
};

export function CardReview({
  durabilityGrade,
  stabilityGrade,
  wetGripGrade,
  noiseLevel,
  drivabilityGrade,
  confortGrade,
  clientName,
  date,
  vehicle,
  comment
}: ReviewProps) {
  return (
    <Flex w="720px" justify={"space-between"}>
      <Flex w="40%" mr="20px">
        <Flex direction="column" alignItems="center">
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={durabilityGrade} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Durabilidade
            </Text>
          </Flex>
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={stabilityGrade} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Estabilidade
            </Text>
          </Flex>
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={wetGripGrade} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Aderência no molhado
            </Text>
          </Flex>
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={noiseLevel} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Nível de ruído
            </Text>
          </Flex>
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={drivabilityGrade} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Dirigibilidade
            </Text>
          </Flex>
          <Flex direction="row" alignItems="center" w="100%">
            <Box>
              <IndividualRating generalGrade={confortGrade} />
            </Box>
            <Text fontSize="14px" ml="1rem" color={"#58585A"}>
              Conforto
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex w="50%" direction="column">
        <Text textStyle="Bold">{clientName}</Text>
        <Text fontSize="text1">
          <strong> Em:</strong> {date}
        </Text>
        <Text fontSize="text1">
          <strong> Automóvel:</strong> {vehicle}
        </Text>
        <Text fontSize="text1" alignItems="justify">
          <strong> Comentário:</strong> {comment}
        </Text>
      </Flex>
    </Flex>
  );
}
